import qs from 'qs';
import moment from 'moment';
import { Env, Storage, I18N } from 'core';
import { Toast as vToast } from 'vant';
import toastSuccess from '../assets/images/toast_success@2x.png';
import toastError from '../assets/images/toast_error@2x.png';

declare const window: any;

export const urlQuery = (url: string, query: { [key: string]: any }, hash = '') => {
  const urls = url?.split('?');
  return `${urls?.[0] || url}?${urls?.[1] ? `${urls?.[1]}&` : ''}${qs.stringify(query, {
    encode: false,
  })}${hash}`;
};

export const openNewPage = (url: string, params?: { [key: string]: any }) => {
  const module = window.Fusion?.loadModule('newPageModule');
  // eslint-disable-next-line no-console
  console.log('openNewPage: ', url);
  if (module?.openNewPage) {
    module.openNewPage({
      url,
      ...params,
    });
  } else {
    window.location.href = url;
  }
};

export const goToOldPage = (path: string, query?: { [key: string]: any }) => {
  openNewPage(
    urlQuery(`${Env.OLD_PAGE}${path}`, {
      ...Storage.getCommonQuery(),
      ...query,
    }),
  );
};

export const Toast = {
  info: (message: string, onClose?: () => void) => vToast({
    message,
    position: 'bottom',
    onClose,
  }),
  success: (message: string, onClose?: () => void) => vToast({
    message,
    icon: toastSuccess,
    position: 'bottom',
    onClose,
  }),
  error: (message: string, onClose?: () => void) => vToast({
    message,
    icon: toastError,
    position: 'bottom',
    onClose,
  }),
};

export const checkEmail = (email: string) => /^([A-Za-z0-9_.-])+@([A-Za-z0-9_.-])+\.([A-Za-z])+$/.test(email);

export const { Fusion } = window;

export const checkBridge = (fuc: string) => {
  const globalWindow = window as any;
  return globalWindow?.Fusion?.[fuc];
};

export const runBridge = (fuc: string, args: any, callback?: (res?: any) => void) => {
  const globalWindow = window as any;
  globalWindow?.Fusion?.[fuc](args, callback);
};

// 获取当前周周一到当天
// 输出 { startTime, endTime }
export const getNowWeek = () => {
  const now = new Date();
  return {
    startTime: moment(now).startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss'),
    endTime: moment(now).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
  };
};

// 获取前7天时间段（包含当天）
// 输出 { startTime, endTime }
export const getSenvenDays = () => {
  const now = new Date();
  return {
    startTime: moment(now).subtract(6, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
    endTime: moment(now).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
  };
};

const monthTxt: { [key: number]: string } = {
  1: I18N.translate('Fleet_Resdesign_January_MKno', 'Jan'),
  2: I18N.translate('Fleet_Resdesign_February_XtXo', 'Feb'),
  3: I18N.translate('Fleet_Resdesign__Biaz', 'Mar'),
  4: I18N.translate('Fleet_Resdesign_April_Qtaf', 'Apr'),
  5: I18N.translate('Fleet_Resdesign__ucKv', 'May'),
  6: I18N.translate('Fleet_Resdesign_June_slTp', 'Jun'),
  7: I18N.translate('Fleet_Resdesign_July_Zroi', 'Jul'),
  8: I18N.translate('Fleet_Resdesign_August_mcie', 'Aug'),
  9: I18N.translate('Fleet_Resdesign_September_MGfs', 'Sep'),
  10: I18N.translate('Fleet_Resdesign_October_pbZU', 'Oct'),
  11: I18N.translate('Fleet_Resdesign_November_kXkU', 'Nov'),
  12: I18N.translate('Fleet_Resdesign_December_uJlY', 'Dec'),
};

// 输入 2021-01-18 00:00:00，2021-01-18 00:00:00
// 输出 5 Aug - 11 Aug
export const getMonthTips = (startTime: string, endTime: string) => {
  let result = '';
  const startMonth = moment(startTime).month() + 1; // (0 - 11) + 1 相当于 1~12
  const startDate = moment(startTime).date();
  const endMonth = moment(endTime).month() + 1;
  const endDate = moment(endTime).date();
  result = `${startDate} ${monthTxt[startMonth]} - ${endDate} ${monthTxt[endMonth]}`;
  return result;
};

export enum MoneySplitEnum {
  unit = 0, // 单位
  float = 1, // 包含两位小数的金额
  int = 2, // 金额整数
  unitAndFloact = 3 // 单位和包含两位小数的金额
}

// 数组中获取金额， 默认返回单位和包含小数的金额
export const getMoney = (
  split: Array<string> | null,
  type: MoneySplitEnum = MoneySplitEnum.unitAndFloact,
) => (Array.isArray(split) ? split?.[type] || '' : '');
// 金额单位消除负号
export const removeMinusSign = (money: number | string) => `${money}`.replace('-', '');

// 控制端上导航和Tab
export const showFleetHomePageTab = (routerName: string) => {
  const tabNameList: string[] = ['home', 'driver', 'vehicle', 'mine', 'homeNew'];
  const name: any = routerName || '';
  const isHomaPage = tabNameList.includes(name);
  const noNavigator: boolean = ['profileHeadPic', 'uploadHeadPic', 'resPage'].includes(name); // 需要隐藏导航，不能触发setImmerse
  if (Fusion?.setImmerse && Fusion?.showFleetHomePageTab && !noNavigator) {
    // 沉浸模式，app上面的区域
    Fusion.setImmerse(
      {
        isImmerse: isHomaPage || routerName === 'easyStart' ? 1 : 0,
      },
      () => ({}),
    );
    // 首页Tab
    Fusion.showFleetHomePageTab(
      {
        isShow: isHomaPage ? 1 : 0,
      },
      () => ({}),
    );
  }
};

// 版本号比较
export const compareVersion = (v1: string, v2: string) => {
  const a1 = v1.split('.').map((e) => Number(e));
  const a2 = v2.split('.').map((e) => Number(e));
  const len = Math.max(a1.length, a2.length);
  for (let i = 0; i < len; i += 1) {
    if ((a1[i] || 0) > (a2[i] || 0)) return 1;
    if ((a1[i] || 0) < (a2[i] || 0)) return -1;
  }
  return 0;
};

export const isH5 = !checkBridge('exitLogin');

// 深度克隆函数，能够适用对象、数组多次嵌套的场景
// 在不改变原state中的对象数据的情况下更新state时，则需要深度克隆函数克隆原数据，进行修改，然后setState
export const deepCopy = (oldObj: any) => {
  let newObj: any;
  if (Array.isArray(oldObj)) {
    newObj = [];
  } else if (typeof oldObj === 'object') {
    newObj = {};
  } else {
    // console.log('error, params is not object');
    return null;
  }

  for (const index in oldObj) {
    if (Object.prototype.hasOwnProperty.call(oldObj, index)) {
      if (oldObj[index] !== null && typeof oldObj[index] === 'object') {
        newObj[index] = deepCopy(oldObj[index]);
      } else {
        newObj[index] = oldObj[index];
      }
    }
  }

  return newObj;
};
